module.exports = __webpack_public_path__ + "img/1528036374.2ffd79e8.jpg";